import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=3351707b&scoped=true"
import script from "./ReferenceModal.vue?vue&type=script&lang=js"
export * from "./ReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceModal.vue?vue&type=style&index=0&id=3351707b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351707b",
  null
  
)

export default component.exports